import React from 'react';
import {Popup} from 'semantic-ui-react';
import {TooltipPosition} from './types';

export interface TooltipProps {
    tooltip?: string;
    position?: TooltipPosition;
    inverted?: boolean;
    className?: string;
    wrapperClassname?: string;
    children: JSX.Element;
    delay?: number;
    zIndex?: number;
}

export const Tooltip = (props: TooltipProps) => {
    const {
        tooltip,
        position = 'bottom center',
        inverted = true,
        className,
        delay = 0,
        children,
        wrapperClassname,
        zIndex
    } = props;
    if (tooltip) {
        const textAlign = 'start';
        const styles = zIndex ? {textAlign, zIndex} : {textAlign};

        return (
            <Popup
                trigger={<div className={`tooltip-wrapper ${wrapperClassname}`}>{children}</div>}
                content={tooltip}
                position={position}
                inverted={inverted}
                className={className}
                mouseEnterDelay={delay}
                style={styles}
            />
        );
    }
    return children;
};
